import React, { useCallback } from "react";
import { Button } from "nr1";


const StoreFilterToolbar = ({
  filter,
  setFilter,
  counts,
  pageSize,
  setPageSize,
  setSelectedStore,
  onBackToServicesList,
  onBack,
  t,
}) => {
  const handleBack = useCallback(() => {
    if (typeof onBack === "function") return onBack();
    if (typeof onBackToServicesList === "function")
      return onBackToServicesList();
  }, [onBack, onBackToServicesList]);

  return (
    <div className="toolbar">
  <div className="filter-buttons">
    {["All", "Healthy", "Unhealthy", "Amber"].map((type) => (
      <Button
        key={type}
        onClick={() => {
          setFilter(type);
          setSelectedStore([]);
        }}
        className={`button-spacing ${filter === type ? "clicked-button" : ""}`}
        title={`Show ${type.toLowerCase()} stores`}
      >
        {t(type.toLowerCase())}
        <span className="badge-count">({counts?.[type.toLowerCase()] ?? 0})</span>
      </Button>
    ))}
  </div>

  <div className="controls">
    <button
      className="back-button"
      onClick={handleBack}
      type="button"
      aria-label={t("back", { defaultValue: "Back" })}
    >
      ← {t("back", { defaultValue: "Back" })}
    </button>

    <div className="dropdown-wrapper">
      <span className="dropdown-label">
        {t("storesPerPage", { defaultValue: "Stores per page" })}
      </span>
      <select
        className="styled-select"
        value={pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value));
          setSelectedStore([]);
        }}
      >
        {[100, 250, 500].map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
    </div>
  </div>
</div>
  );
};

export default StoreFilterToolbar;
